import { getAge } from '@lyrahealth-inc/shared-app-logic/src/features/searchForCare/utils'
import { GetCustomerCopyFunc } from '@lyrahealth-inc/shared-app-logic/src/models/customer/Customer'

export const nationwidechildrens: GetCustomerCopyFunc = () => {
  return {
    shouldUseCustomChildCare: (childDOB: string) => getAge({ date: childDOB }) < 6,
  }
}
